<template>
  <div class="vacancy-response">
    <ResumeCard
      :resume="response.author"
      :date="response.publishedAt"
      :has-collapsed-section="hasCollapsedSection"
    >
      <template #additional>
        <ContentSection
          v-if="(response.message && response.messageHtml) || $slots.message"
          title="Сопроводительное письмо"
        >
          <div class="vacancy-response__message">
            <slot name="message">
              <StyleUgc :ugc="response.messageHtml" />
            </slot>
          </div>
        </ContentSection>
        <ContentSection v-if="quickResponseAccuracy">
          <template #title>
            <div class="vacancy-response__quick-response-title">
              <span>Быстрый отклик</span>
              <span
                class="vacancy-response__quick-response-tooltip"
                title="Кандидат может откликнуться на вакансию с помощью отклика в один клик прямо из ленты"
              >
                <SvgIcon icon="tooltip" size="20" color="muted" />
              </span>
            </div>
          </template>
          <div class="vacancy-response__message">
            Профиль соответствует вакансии на {{ quickResponseAccuracy }}%
          </div>
        </ContentSection>
      </template>
      <template #actions>
        <slot name="controls" />

        <slot name="footer" />
      </template>
    </ResumeCard>
  </div>
</template>

<script>
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
import ResumeCard from 'src/components/resumes/ResumeCard/ResumeCard.vue';
import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';
import StyleUgc from 'src/components/StyleUgc/StyleUgc.vue';

export default {
  name: 'VacancyResponse',
  components: {
    StyleUgc,
    SvgIcon,
    ContentSection,
    ResumeCard,
  },
  props: {
    response: {
      type: Object,
      required: true,
    },
    hasCollapsedSection: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    quickResponseAccuracy() {
      if (!this.response.vacancyRecommendationAccuracyPercent) return null;

      return Math.round(this.response.vacancyRecommendationAccuracyPercent);
    },
  },
};
</script>
